<template>
  <Blocks :blocks="config" :customComponents="customComponents"></Blocks>
</template>

<script>
import { Blocks } from '@kvass/pagebuilder'
import Slider from '@/components/Slider.vue'
import config from '@/config/subpages/buildings.js'

export default {
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    config() {
      return config.call(this.value)
    },
    customComponents() {
      return { Slider }
    },
  },
  components: {
    Blocks,
    Slider,
  },
}
</script>

<style lang="scss"></style>
